var chunkMapping = {
	"748": [
		50748
	],
	"973": [
		20973
	],
	"1482": [
		41482
	],
	"2375": [
		92375
	],
	"4059": [
		24059
	],
	"4191": [
		84191
	],
	"7491": [
		67491
	],
	"8092": [
		18092
	],
	"8403": [
		88403
	],
	"8426": [
		78426
	],
	"9888": [
		19888
	]
};
var idToExternalAndNameMapping = {
	"18092": [
		"default",
		"./AppointmentBookingModal",
		38939
	],
	"19888": [
		"default",
		"./PackageCreate",
		94670
	],
	"20973": [
		"default",
		"./TermFormBuilder",
		42175
	],
	"24059": [
		"default",
		"./FingerprintPanel",
		42175
	],
	"41482": [
		"default",
		"./VoucherApplyPanel",
		94670
	],
	"50748": [
		"default",
		"./PatientGeneralInformationForm",
		42175
	],
	"67491": [
		"default",
		"./FingerprintCapture",
		42175
	],
	"78426": [
		"default",
		"./AppointmentCalendar",
		38939
	],
	"84191": [
		"default",
		"./ClinicalXflowModule",
		19840
	],
	"88403": [
		"default",
		"./AppointmentModule",
		38939
	],
	"92375": [
		"default",
		"./XmlValidatorModule",
		61130
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}